module.exports = "/_next/static/images/Personalization102AdvancedGuideToPersonalization-128f582ebfad665102799c4b2c61be7c.png";